import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStandardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={63}
    height={75}
    fill="none"
    viewBox="0 0 63 75"
    {...props}
  >
    <path
      fill="#FF5836"
      d="M62.594 43.019c.164-9.246-4.26-18.048-11.259-23.9v47.73c7.07-5.876 11.4-14.842 11.26-23.83M11.799 20.125l8.59 7.514c.094-.07 7.35-4.494 7.35-4.494v39.443c-13.693-2.833-20.083-18.75-11.844-30.29L7.422 24.9C-6.718 43.58 3.817 68.51 24.369 73.52c.983.234 4.494.866 7.818.866 4.471 0 7.912-1.264 7.936-1.264V.509S11.939 20.032 11.799 20.125"
    />
  </svg>
);
export default SvgStandardIcon;
